export default function SquareMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1778)">
                <rect width="100%" height="100%" fill="#FF89C2" />
                <path d="M1000 500L500 -0.000488281L-5.60527e-05 500L500 1000L1000 500Z" fill="#1C5DCC" />
                <path d="M737.489 500.004L500 262.515L262.511 500.004L500 737.493L737.489 500.004Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1778">
                    <rect width="100%" height="100%" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}